import api from './api';
import { SiteSettings, SiteSettingsFormData } from '@/types/settings';

export const settingsApi = {
    // Get site settings
    async getSettings(): Promise<SiteSettings> {
        try {
            const response = await api.get('/admin/settings');
            return response.data;
        } catch (error: any) {
            console.error('Error fetching settings:', error);
            throw new Error(error.response?.data?.error || 'Ayarlar yüklenemedi');
        }
    },

    // Update site settings
    async updateSettings(settingsData: SiteSettingsFormData): Promise<SiteSettings> {
        try {
            const response = await api.put('/admin/settings', settingsData);
            return response.data;
        } catch (error: any) {
            console.error('Error updating settings:', error);
            throw new Error(error.response?.data?.error || 'Ayarlar güncellenemedi');
        }
    },
};
